import { useCallback } from 'react'
import { useLocation } from 'react-use'

export const useCompareRoute: () => (l: string) => boolean = () => {
  const loc = useLocation()

  const formatString: (s: string) => string = (s) =>
    s.replace(/-| |&/g, '').toLowerCase()

  const compare: (l: string) => boolean = useCallback(
    (l) =>
      loc
        ? loc.pathname
          ? formatString(loc.pathname.split('/').pop() ?? '') === formatString(l)
          : false
        : false,
    [loc]
  )

  return compare
}
